<div class="page">

  <div class="pagehead">
    <div>
      <h1>DTH recharge</h1>
      <p>Recharge any DTH connection with the operator and customer ID</p>
    </div>
  </div>

  <div class="notes" *ngIf="noteData && noteData.length">
    <div class="note-row" *ngFor="let i of noteData">
      <i class="fa fa-info-circle" aria-hidden="true"></i><label>{{ i.message }}</label>
    </div>
  </div>

  <div class="card form-card">
    <div class="clabel"><svg viewBox="0 0 24 24"><rect x="2" y="5" width="20" height="13" rx="2"/><path d="M8 21h8"/></svg>Recharge details</div>
    <form [formGroup]="dthRechargeForm" class="kit-form" #form="ngForm">
      <div class="form-grid">
        <div class="er-field"
          [class.has-error]="dthRechargeForm.get('dthoperator').invalid && (dthRechargeForm.get('dthoperator').touched || form.submitted)">
          <label class="er-field__label" for="dth-operator">Operator <span class="req">*</span></label>
          <select id="dth-operator" class="er-select" formControlName="dthoperator">
            <option value="" disabled selected hidden>Select the DTH operator</option>
            <option [value]="operator.parameterValue" *ngFor="let operator of dthOperatorsList">{{ operator.providerName }}</option>
          </select>
          <div class="er-field__error" *ngIf="dthRechargeForm.hasError('required','dthoperator') && (dthRechargeForm.get('dthoperator').touched || form.submitted)">Select the operator</div>
        </div>

        <div class="er-field"
          [class.has-error]="dthRechargeForm.get('customer_Id').invalid && (dthRechargeForm.get('customer_Id').touched || form.submitted)">
          <label class="er-field__label" for="dth-customer">Customer ID <span class="req">*</span></label>
          <div class="er-field__wrap">
            <input id="dth-customer" class="er-field__control er-field__control--mono" type="text"
              formControlName="customer_Id" placeholder="Subscriber / customer ID" autocomplete="off">
          </div>
          <div class="er-field__help" *ngIf="msgdivshow == true && opsmsg">{{ opsmsg }}</div>
          <div class="er-field__error" *ngIf="dthRechargeForm.hasError('required','customer_Id') && (dthRechargeForm.get('customer_Id').touched || form.submitted)">Enter the customer ID</div>
        </div>

        <div class="er-field er-field--amount"
          [class.has-error]="dthRechargeForm.get('dthrechargeamount').invalid && (dthRechargeForm.get('dthrechargeamount').touched || form.submitted)">
          <label class="er-field__label" for="dth-amount">Amount <span class="req">*</span></label>
          <div class="er-field__wrap">
            <span class="er-field__affix">₹</span>
            <input id="dth-amount" class="er-field__control" type="text" formControlName="dthrechargeamount"
              placeholder="0" inputmode="numeric" autocomplete="off" (keypress)="numberOnly($event)">
          </div>
          <div class="er-field__error" *ngIf="dthRechargeForm.hasError('required','dthrechargeamount') && (dthRechargeForm.get('dthrechargeamount').touched || form.submitted)">Enter the amount</div>
        </div>
      </div>

      <div class="form-actions">
        <button type="button" class="er-btn er-btn--primary" (click)="dthRecharge(confirmationModal)">Proceed to recharge</button>
      </div>
    </form>
  </div>

</div>

<ng-template #confirmationModal let-c="close" let-d="dismiss">
  <ngx-spinner bdColor="rgba(6, 7, 8, 0.88)" size="medium" color="#01DC64" type="ball-clip-rotate" [fullScreen]="true"><p style="color: white"> Processing... </p></ngx-spinner>
  <div class="modal-header er-modal-head">
    <h5 class="modal-title" id="modal-basic-title">Confirm recharge</h5>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p class="confirm-tag">Recharge of ₹{{ dthRechargeForm.value.dthrechargeamount }} for customer ID {{ dthRechargeForm.value.customer_Id }} ({{ dthRechargeForm.value.dthoperator }})</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="er-btn er-btn--ghost" aria-label="Close" (click)="d('Cross click')">Cancel</button>
    <button type="button" class="er-btn er-btn--primary" (click)="dthRechargeNow(confirmationModal,finalModal)">Recharge</button>
  </div>
</ng-template>

<ng-template #finalModal let-c="close" let-d="dismiss">
  <div class="modal-header er-modal-head">
    <h5 class="modal-title" id="modal-basic-title">{{ rechargeInfo.dthdetails.rechargeStatus }}</h5>
  </div>
  <div class="modal-body">
    <div class="er-success-check" aria-hidden="true">
      <svg viewBox="0 0 52 52"><circle cx="26" cy="26" r="24"/><path d="M15 27l7 7 15-15"/></svg>
    </div>
    <div class="row" *ngIf="rechargeInfo" style="font-size: 14px; font-weight: 500;">
      <div class="col-md-6">
        <label>Transaction Id:<br> {{ rechargeInfo.transactionReference }}</label><br>
        <label>Amount: ₹{{ rechargeInfo.amount }}</label>
        <br><br>
        <label>Opening balance:<br> ₹{{ rechargeInfo.openingBalance }}</label><br>
      </div>
      <div class="col-md-6">
        <label>Customer Id:<br> {{ rechargeInfo.dthdetails.dthNumber }}</label><br>
        <label> {{ rechargeInfo.trasactionDate | date:'dd MMM yy, h:mm a' }}</label><br><br>
        <label>Closing balance: <br>₹{{ rechargeInfo.closeingBalance }}</label><br>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="er-btn er-btn--primary" (click)="closeFinal(finalModal)">Okay</button>
  </div>
</ng-template>

<ng-template #serviceModal let-c="close" let-d="dismiss">
  <div class="modal-header er-modal-head">
    <h5 class="modal-title" id="modal-basic-title">DTH recharge service unavailable</h5>
  </div>
  <div class="modal-body" style="text-align:center;">
    <img src="../../../assets/images/images/serviceUnavailable.png" style="width: 35%;">
    <h6>{{ serviceData.message }}</h6>
  </div>
  <div class="modal-footer">
    <button type="button" class="er-btn er-btn--primary" style="margin: auto;" *ngIf="serviceData.message != 'Invalid User Authentication. YM'" (click)="closeServiceModal(serviceModal)">Okay</button>
    <button type="button" class="er-btn er-btn--primary" style="margin: auto;" *ngIf="serviceData.message == 'Invalid User Authentication. YM'" (click)="closeServiceModalOut(serviceModal)">Okay</button>
  </div>
</ng-template>

